module.exports = "https://cdn.hellotech.com/client-assets/walmart-header-logo_bfd2aef1b61577d98a993f2e642a3066.svg";